import { Directive, HostListener, Inject } from '@angular/core';
import { WindowShellComponent } from '../components/window-shell/window-shell.component';
import { WINDOW_REF } from '../providers';

@Directive({
  selector: '[bmWindowFocus]'
})
export class WindowFocusDirective {

  constructor(@Inject(WINDOW_REF) private windowRef: WindowShellComponent) { }

  @HostListener('mousedown')
  focusWindow() {
    this.windowRef.focus();
  }

}
